import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import CryptoJS from 'crypto-js';

const saveToLocalStorage = (state) => {
  try {
    // Salva solo se esiste un utente autenticato con uid
    if (state && state.authUser && state.authUser.uid) {
      const serializedUid = CryptoJS.AES.encrypt(
        JSON.stringify(state.authUser),
        'my-secret-key'
      ).toString();
      localStorage.setItem('authUser', serializedUid);
    } else {
      // rimuove la chiave se non c'è utente autenticato
      localStorage.removeItem('authUser');
    }
  } catch (err) {
    // non vogliamo bloccare l'app in caso di errori con la storage
    console.error('saveToLocalStorage error', err);
  }
};

const checkLocalStorage = () => {
  try {
    const serializedUid = localStorage.getItem('authUser');
    if (!serializedUid) return undefined;
    const decrypted = CryptoJS.AES.decrypt(serializedUid, 'my-secret-key').toString(
      CryptoJS.enc.Utf8
    );
    const parsed = JSON.parse(decrypted);
    // se parsed non contiene uid consideriamolo come non autenticato
    if (!parsed || !parsed.uid) return undefined;
    return { authUser: parsed };
  } catch (err) {
    // Se la decrittazione/parsing fallisce, rimuoviamo la voce corrotta e ritorniamo undefined
    console.warn('checkLocalStorage failed, clearing authUser', err);
    try {
      localStorage.removeItem('authUser');
    } catch (e) {
      /* ignore */
    }
    return undefined;
  }
};

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
let store = createStore(rootReducer, checkLocalStorage(), composeEnhancers(applyMiddleware(thunk)));

store.subscribe(() => saveToLocalStorage(store.getState()));
export default store;
